import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AssignCoursesList from "../components/AssignCourseList";

const AssignCoursesPage = () => {
  return (
    <>

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Assigned Courses  </h5><Breadcrumb title="Assigned Courses" /></div>

        {/* AssignRoleLayer */}
        <AssignCoursesList />

    </>
  );
};

export default AssignCoursesPage;
